var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Max documents")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      min: -1,
                      decimals: 0,
                      label: "Maximum aantal documenten per maand",
                    },
                    model: {
                      value: _vm.maxDocuments,
                      callback: function ($$v) {
                        _vm.maxDocuments = $$v
                      },
                      expression: "maxDocuments",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      min: 0,
                      decimals: 0,
                      label: "Aantal documenten gemaakt deze maand",
                    },
                    model: {
                      value: _vm.madeCount,
                      callback: function ($$v) {
                        _vm.madeCount = $$v
                      },
                      expression: "madeCount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-date-picker", {
                    attrs: { label: "Laatste document gemaakt op" },
                    model: {
                      value: _vm.lastDocumentMadeDate,
                      callback: function ($$v) {
                        _vm.lastDocumentMadeDate = $$v
                      },
                      expression: "lastDocumentMadeDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }